import {reqget, reqpost} from './axiosFun';


export const pageRechargeCombo = (params) => { return reqget("get", "/api/recharge/combo/list", params) };
export const pageCoinFlow = (params) => { return reqget("get", "/api/recharge/coin/flow/list", params) };
export const walletCoins = (params) => { return reqget("get", "/api/recharge/coins", params) };
export const newRechargeCombo = (params) => { return reqpost("post", "/api/recharge/combo/new", params) };
export const updateRechargeCombo = (params) => { return reqpost("post", "/api/recharge/combo/update", params) };
export const deleteRechargeCombo = (params) => { return reqpost("delete", `/api/recharge/combo/${params.ids}`, params) };
export const rechargeOperate = (params) => { return reqpost("post", "/api/recharge/operate", params) };



// WEBPACK FOOTER //
// ./src/api/rechargeMG.js